(function(){
  var bar = document.querySelector('.tlp-bar[data-bar]');
  if(!bar) return;
  var labelEl = bar.querySelector('[data-label]'), countEl = bar.querySelector('[data-count]'),
      hintEl = bar.querySelector('[data-hint]'), nowEl = bar.querySelector('[data-now]'),
      wasEl = bar.querySelector('[data-was]'), addBtn = bar.querySelector('[data-add]'),
      toast = document.querySelector('.tlp-toast[data-toast]');
  var active = null;
  var barUnlocked = false;
  function money(n){ return '$'+n.toFixed(2); }

  /* ---- Size handling (2026-09-24) -----------------------------------------
     The builder used to take vs[0] - the product's FIRST variant - as each
     item's default. Every shirt and polo lists XS first, so tapping three
     swatches and hitting Add produced three XS Slim shirts, and the Add button
     enabled whether or not the shopper had touched a size dropdown. Against
     real demand since June (M/Slim 9,916 units, L/Slim 8,968, XS not in the
     top fifteen) that default was close to the worst available guess. It cost
     orders at the cart and produced wrong-size returns from the ones that went
     through.

     Defaults now run through chooseVariant(), which walks a preference chain
     and matches on option NAME rather than position - so it behaves the same
     on shirts (Size / Fit / Sleeve Length) and polos (Size / Fit / Color), and
     leaves Sleeve Length and Color alone. tlp-swatch only emits variants where
     v.available, so anything chosen here is in stock; the chain simply falls
     through to the next size when a product has no M. */
  var SIZE_PREF = ['M','L','S','XL','2XL','XS','3XL','4XL','5XL'];
  var FIT_PREF  = ['Slim','Athletic','Classic (Athletic)','Classic'];
  var SIZE_ORDER = ['XS','S','M','L','XL','2XL','3XL','4XL','5XL'];

  function optIdx(onames, target){
    for(var i=0;i<onames.length;i++){
      if((onames[i]||'').trim().toLowerCase() === target) return i;
    }
    return -1;
  }

  function chooseVariant(item, wantSize, wantFit){
    var vs = item.variants;
    if(!vs || !vs.length) return null;
    var si = optIdx(item.onames,'size'), fi = optIdx(item.onames,'fit');
    if(si < 0 && fi < 0) return vs[0];

    var sizes = [];
    if(wantSize) sizes.push(wantSize);
    SIZE_PREF.forEach(function(s){ if(sizes.indexOf(s) === -1) sizes.push(s); });
    var fits = [];
    if(wantFit) fits.push(wantFit);
    FIT_PREF.forEach(function(f){ if(fits.indexOf(f) === -1) fits.push(f); });

    for(var a=0;a<sizes.length;a++){
      var pool = (si < 0) ? vs : vs.filter(function(v){ return (v.vals[si]||'') === sizes[a]; });
      if(!pool.length) continue;
      if(fi < 0) return pool[0];
      for(var c=0;c<fits.length;c++){
        var p2 = pool.filter(function(v){ return (v.vals[fi]||'') === fits[c]; });
        if(p2.length) return p2[0];
      }
      return pool[0];
    }
    return vs[0];
  }

  function parseVariants(str){
    return (str||'').split('||').filter(Boolean).map(function(x){
      var p=x.split('::'); return { vals:(p[0]||'').split('~'), id:p[1], price:parseFloat(p[2]) };
    });
  }
  function setPreview(b,img,title){ if(img) b.pv.style.backgroundImage="url('"+img+"')"; b.pvname.textContent=title; }
  function resolveVariant(item){
    return item.variants.filter(function(v){
      for(var i=0;i<item.onames.length;i++){ if((v.vals[i]||'')!==(item.sel.vals[i]||'')) return false; }
      return true;
    })[0] || null;
  }
  function buildSelects(item){
    var html='';
    for(var i=0;i<item.onames.length;i++){
      var seen={}, vals=[];
      item.variants.forEach(function(v){ var x=v.vals[i]||''; if(x && !seen[x]){ seen[x]=1; vals.push(x); } });
      if(vals.length<1) continue;
      html+='<select data-oi="'+i+'">'+vals.map(function(x){
        return '<option value="'+x+'"'+(x===(item.sel.vals[i]||'')?' selected':'')+'>'+x+'</option>';
      }).join('')+'</select>';
    }
    return html;
  }

  function makeItem(b, btn){
    var vs = parseVariants(btn.dataset.variants);
    if(!vs.length) return null;
    var item = {
      btn: btn, title: btn.dataset.title, img: btn.dataset.img,
      onames: (btn.dataset.optnames||'').split('~').filter(Boolean),
      variants: vs, sel: null
    };
    var v = chooseVariant(item, b.wantSize, b.wantFit) || vs[0];
    item.sel = { id: v.id, price: v.price, vals: v.vals.slice() };
    return item;
  }

  function renderTray(b){
    b.tray.innerHTML='';
    for(var i=0;i<b.qty;i++){
      var item=b.selected[i];
      var slot=document.createElement('div'); slot.className='slot'+(item?' full':'');
      if(!item){ slot.innerHTML='<span class="plus">+</span> Pick a '+b.noun; }
      else {
        slot.innerHTML='<div class="chip" style="background-image:url(\''+item.img+'\')"></div>'+
          '<div class="sbody"><div class="sname">'+item.title+'</div><div class="sels">'+buildSelects(item)+'</div></div>'+
          '<button class="rm" aria-label="remove">&times;</button>';
        (function(item,slot){
          slot.querySelectorAll('select').forEach(function(se){
            se.addEventListener('change', function(){
              var oi=parseInt(this.dataset.oi,10);
              item.sel.vals[oi]=this.value;
              var v=resolveVariant(item);
              if(!v){ v=item.variants.filter(function(x){return (x.vals[oi]||'')===item.sel.vals[oi];})[0]||item.variants[0]; item.sel.vals=v.vals.slice(); }
              item.sel.id=v.id; item.sel.price=v.price;
              b.touched = true; unlockBar(); renderAll(b);
            });
          });
          slot.querySelector('.rm').addEventListener('click', function(){ toggle(b,item.btn); });
        })(item,slot);
      }
      b.tray.appendChild(slot);
    }
    if(b.noteEl){
      var showNote = b.prefilled && !b.touched && b.selected.length >= b.qty;
      b.noteEl.style.display = showNote ? 'flex' : 'none';
    }
  }
  function renderDots(b){ var n=b.selected.length; b.dots.forEach(function(d,i){ d.classList.toggle('on', i<n); }); }

  /* A full pack used to dim every unpicked swatch and set pointer-events:none,
     which was survivable when you built the pack yourself but is a dead end now
     that the shirt pack arrives pre-filled - you'd have to remove something
     before you could choose anything. Tapping a swatch on a full pack now swaps
     out the oldest item instead, so the grid is always live. */
  function renderDim(b){ b.swatches.forEach(function(s){ s.classList.remove('dim'); }); }

  function renderBar(){
    if(!active){ bar.classList.remove('show'); return; }
    var b=active, n=b.selected.length;
    bar.classList.toggle('show', barUnlocked && n>0);
    labelEl.textContent=b.label; countEl.textContent=n+'/'+b.qty;
    var chosen=b.selected.map(function(it){return it.sel.price;});
    var sum=chosen.reduce(function(a,c){return a+c;},0);
    if(n<b.qty){
      nowEl.textContent=money(sum); wasEl.style.display='none';
      hintEl.textContent=b.mode==='bxgy' ? '— add '+(b.qty-n)+' more, cheapest is free' : '— add '+(b.qty-n)+' more to unlock $'+b.price;
      addBtn.disabled=true; addBtn.textContent=b.cta;
    } else {
      var total=b.mode==='bxgy' ? (sum-Math.min.apply(null,chosen)) : b.price;
      nowEl.textContent=money(total); wasEl.textContent=money(sum); wasEl.style.display='inline';
      hintEl.textContent=b.mode==='bxgy' ? '— cheapest is free!' : '— you saved '+money(sum-total)+'!';
      addBtn.disabled=false; addBtn.textContent=b.cta+' · '+money(total);
    }
  }
  function renderAll(b){
    renderTray(b); renderDots(b); renderDim(b);
    if(b.selected.length || !active) active=b;
    renderBar();
  }
  function unlockBar(){ if(barUnlocked) return; barUnlocked = true; renderBar(); }

  function toggle(b,btn){
    var idx=-1; b.selected.forEach(function(it,i){ if(it.btn===btn) idx=i; });
    if(idx>=0){
      b.selected.splice(idx,1); btn.classList.remove('sel');
    } else {
      if(b.selected.length >= b.qty){
        var out = b.selected.shift();
        if(out && out.btn) out.btn.classList.remove('sel');
      }
      var item = makeItem(b, btn);
      if(!item) return;
      b.selected.push(item);
      btn.classList.add('sel');
      setPreview(b, btn.dataset.img, btn.dataset.title);
    }
    b.touched = true;
    unlockBar();
    renderAll(b);
  }

  /* ---- "What's your size?" ------------------------------------------------
     Picking three shirts meant up to nine dropdowns (size, fit and sleeve on
     each). One control per pack now governs Size and Fit for every item, and
     the per-item dropdowns stay for anyone who wants a different size on one
     shirt. Values are the union of what's actually in stock across the swatch
     set, so we never offer a size nothing is available in. */
  function collectValues(b, target){
    var out=[], seen={};
    b.swatches.forEach(function(sw){
      var onames=(sw.dataset.optnames||'').split('~').filter(Boolean);
      var idx=optIdx(onames,target);
      if(idx<0) return;
      parseVariants(sw.dataset.variants).forEach(function(v){
        var val=(v.vals[idx]||'').trim();
        if(val && !seen[val]){ seen[val]=1; out.push(val); }
      });
    });
    if(target === 'size'){
      out.sort(function(x,y){
        var a=SIZE_ORDER.indexOf(x), c=SIZE_ORDER.indexOf(y);
        if(a===-1 && c===-1) return x.localeCompare(y);
        if(a===-1) return 1;
        if(c===-1) return -1;
        return a-c;
      });
    }
    return out;
  }

  function firstPreferred(list, pref){
    for(var i=0;i<pref.length;i++){ if(list.indexOf(pref[i])!==-1) return pref[i]; }
    return list[0] || null;
  }

  function buildSizeBar(b){
    var sizes = collectValues(b,'size'), fits = collectValues(b,'fit');
    if(!sizes.length && !fits.length) return;
    b.wantSize = firstPreferred(sizes, SIZE_PREF);
    b.wantFit  = firstPreferred(fits, FIT_PREF);

    var wrap=document.createElement('div');
    wrap.className='bb-fit';
    var html='<span class="bb-fit-q">What’s your size?</span>';
    if(sizes.length){
      html+='<label>Size <select data-gsize>'+sizes.map(function(s){
        return '<option value="'+s+'"'+(s===b.wantSize?' selected':'')+'>'+s+'</option>';
      }).join('')+'</select></label>';
    }
    if(fits.length>1){
      html+='<label>Fit <select data-gfit>'+fits.map(function(f){
        return '<option value="'+f+'"'+(f===b.wantFit?' selected':'')+'>'+f+'</option>';
      }).join('')+'</select></label>';
    }
    html+='<span class="bb-fit-note">Applies to all '+b.qty+' — you can change any one of them below.</span>';
    wrap.innerHTML=html;

    var cfg=b.el.querySelector('.bb-config');
    if(cfg && cfg.parentNode) cfg.parentNode.insertBefore(wrap, cfg);
    else b.el.appendChild(wrap);

    var gs=wrap.querySelector('[data-gsize]'), gf=wrap.querySelector('[data-gfit]');
    function applyGlobal(){
      b.selected.forEach(function(it){
        var v=chooseVariant(it, b.wantSize, b.wantFit);
        if(v) it.sel={ id:v.id, price:v.price, vals:v.vals.slice() };
      });
      b.touched = true; unlockBar(); renderAll(b);
    }
    if(gs) gs.addEventListener('change', function(){ b.wantSize=this.value; applyGlobal(); });
    if(gf) gf.addEventListener('change', function(){ b.wantFit=this.value; applyGlobal(); });
  }

  function buildPrefillNote(b){
    var note=document.createElement('div');
    note.className='bb-prefill';
    note.innerHTML='<span>✨</span><span>We’ve started you off with '+b.qty+' favourites in <b data-psize></b>. Tap any swatch to swap one out, or change your size above.</span>';
    note.style.display='none';
    if(b.tray && b.tray.parentNode) b.tray.parentNode.insertBefore(note, b.tray);
    b.noteEl=note;
  }

  function initBuilder(el){
    var b={ el:el, mode:el.dataset.mode||'fixed', qty:parseInt(el.dataset.qty,10)||3,
      price:parseFloat(el.dataset.price||'0'), noun:el.dataset.noun||'item', cta:el.dataset.cta||'Add',
      label:el.dataset.label||'Pack', init:parseInt(el.dataset.init,10)||12, discount:el.dataset.discount||'',
      pv:el.querySelector('.bb-preview .pv'), pvname:el.querySelector('.bb-preview .pvname'),
      tray:el.querySelector('.bb-tray'), dots:[].slice.call(el.querySelectorAll('.dot')),
      swatches:[].slice.call(el.querySelectorAll('.sw')), selected:[],
      wantSize:null, wantFit:null, prefilled:false, touched:false, noteEl:null };

    b.swatches.forEach(function(sw){
      sw.addEventListener('mouseenter', function(){ setPreview(b, sw.dataset.img, sw.dataset.title); });
      sw.addEventListener('click', function(){ toggle(b, sw); });
    });
    if(b.swatches.length>b.init){
      b.swatches.forEach(function(sw,i){ if(i>=b.init) sw.classList.add('hide'); });
      var more=document.createElement('button'); more.type='button'; more.className='bb-more';
      more.textContent='Show all '+b.swatches.length+' styles';
      el.querySelector('.bb-swatches').appendChild(more);
      more.addEventListener('click', function(){ b.swatches.forEach(function(sw){ sw.classList.remove('hide'); }); more.remove(); renderDim(b); });
    }

    buildSizeBar(b);
    buildPrefillNote(b);

    /* Pre-fill the fixed-price shirt pack only. The shopper used to land on an
       empty tray reading 0/3 with a disabled button - all of the work, none of
       the value, before anything was worth anything. Now the pack arrives built
       at its offer price and the job becomes swapping rather than assembling.
       The BOGO polo pack is deliberately left empty: nothing should end up in a
       cart that the shopper didn't ask for, and the polo pack is a genuine
       second decision rather than the page's headline offer.

       Which three get picked is just the first three styles in the collection,
       so reordering the collection in Shopify changes the opening pack. */
    if(b.mode === 'fixed' && b.swatches.length >= b.qty){
      for(var i=0;i<b.qty;i++){
        var it = makeItem(b, b.swatches[i]);
        if(it){ b.selected.push(it); b.swatches[i].classList.add('sel'); }
      }
      b.prefilled = b.selected.length === b.qty;
      if(b.noteEl){
        var ps=b.noteEl.querySelector('[data-psize]');
        if(ps) ps.textContent = [b.wantSize, b.wantFit].filter(Boolean).join(' / ') || 'your size';
      }
    }

    if(b.swatches[0]) setPreview(b, b.swatches[0].dataset.img, b.swatches[0].dataset.title);
    renderAll(b);

    /* Hold the sticky bar back until the builder is actually on screen. With a
       pre-filled pack it would otherwise be showing over the hero the instant
       the page loads, before the shopper knows what it refers to. */
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ unlockBar(); io.disconnect(); } });
      }, { rootMargin: '0px 0px -25% 0px' });
      io.observe(el);
    } else { unlockBar(); }
  }

  addBtn.addEventListener('click', function(){
    if(!active) return;
    var items=active.selected.map(function(it){ return { id:parseInt(it.sel.id,10), quantity:1 }; });
    if(items.length<active.qty) return;
    var disc = active.el && active.el.dataset ? active.el.dataset.discount : '';
    addBtn.disabled=true; addBtn.textContent='Adding…';
    fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ items:items }) })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ return disc ? fetch('/discount/'+disc).catch(function(){}) : null; })
      .then(function(){
        if(typeof window.upcartOpenCart==='function'){
          if(typeof window.upcartRefreshCart==='function'){ try{ window.upcartRefreshCart(); }catch(e){} }
          window.upcartOpenCart();
          renderBar();
        } else {
          window.location.href = disc ? '/discount/'+disc+'?redirect=/cart' : '/cart';
        }
      })
      .catch(function(){ renderBar(); if(toast){ toast.textContent='Something went wrong.'; toast.classList.add('show'); setTimeout(function(){toast.classList.remove('show');},2600);} });
  });

  /* Styles for the two elements this file injects. They live here rather than
     in teacher-landing.css so the markup and its styling stay in one place -
     the mission-kit styles went missing once by living in a shared stylesheet
     the sections outlived. */
  (function injectStyles(){
    if(document.getElementById('bb-picker-css')) return;
    var css = '.tlp .bb-fit{display:flex;align-items:center;gap:10px 14px;flex-wrap:wrap;margin:14px 22px 0;padding:12px 14px;border:1px solid var(--line);border-radius:10px;background:var(--mist)}'
      + '.tlp .bb-fit-q{font-weight:800;font-size:13.5px;color:var(--navy)}'
      + '.tlp .bb-fit label{display:inline-flex;align-items:center;gap:6px;font-size:12.5px;font-weight:700;color:var(--muted)}'
      + '.tlp .bb-fit select{font-size:13px;font-weight:600;color:var(--ink);padding:7px 10px;border:1px solid var(--line);border-radius:6px;background:#fff;min-height:38px}'
      + '.tlp .bb-fit-note{font-size:12px;color:var(--muted);flex:1 1 100%}'
      + '@media(min-width:760px){.tlp .bb-fit-note{flex:1 1 auto;text-align:right}}'
      + '.tlp .bb-prefill{display:flex;gap:8px;align-items:flex-start;margin:14px 22px 0;font-size:12.5px;line-height:1.45;color:var(--muted)}'
      + '.tlp .bb-prefill b{color:var(--navy)}';
    var s=document.createElement('style'); s.id='bb-picker-css'; s.textContent=css;
    document.head.appendChild(s);
  })();

  document.querySelectorAll('.tlp .bb').forEach(initBuilder);

  /* ---- Lazy-load the UGC clip strip (2026-09-17) --------------------------
     The clips below the hero are 1080p and were all marked autoplay. autoplay
     overrides preload="metadata", so every clip began downloading the moment
     the page loaded - measured on /3for99 at 68.9MB of video and 852 requests,
     on a page with 614 sessions and 0.0% conversion.

     The clips now ship with preload="none", a poster frame, and their URL in
     data-src; each one is fetched only when it scrolls near. The hero video
     still autoplays - it is the hook, above the fold, and it is a single file.

     NOTE: the Shabbos LP (/shabbos) does NOT load this file - its clips live in
     sections/jewish-hero.liquid, which carries its own copy of this loader.
     If you change the logic here, change it there too. */
  (function lazyVideos(){
    var vids = [].slice.call(document.querySelectorAll('.tlp video.lazy-vid[data-src]'));
    if(!vids.length) return;
    function load(v){
      if(v.dataset.loaded) return;
      v.dataset.loaded = '1';
      var s = document.createElement('source');
      s.src = v.dataset.src; s.type = 'video/mp4';
      v.appendChild(s);
      v.muted = true; v.setAttribute('muted', '');
      v.autoplay = true; v.setAttribute('autoplay', '');
      try { v.load(); } catch(e){}
      var p = v.play(); if(p && p.catch) p.catch(function(){});
    }
    if(!('IntersectionObserver' in window)){ vids.forEach(load); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ load(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '300px 0px' });
    vids.forEach(function(v){ io.observe(v); });
  })();

  /* ---- Attach this page's hidden offer codes on landing -------------------
     Added 2026-09-15. The 3-for-$99 / buy-2-get-1 pricing comes from hidden
     discount codes that were previously attached ONLY when the shopper clicked
     Add. Anyone who landed from an ad and then shopped another way - nav, a
     product page, search - priced at full price despite the ad's promise.

     Safe: every code is minimum-quantity gated and capped, so it does nothing
     to a cart that doesn't qualify. The session flag is written ONLY after
     every code attaches; an earlier version set it up front, so one transient
     failure silently disabled the offer for that shopper's whole session. */
  (function attachOfferCodesOnLanding(){
    var codes = [];
    document.querySelectorAll('.tlp .bb[data-discount]').forEach(function(el){
      var c = (el.dataset.discount || '').trim();
      if (c && codes.indexOf(c) === -1) codes.push(c);
    });
    if (!codes.length) return;

    var KEY = 'ac_lp_offer_attached:' + codes.join(',');
    try { if (sessionStorage.getItem(KEY) === 'ok') return; } catch (e) {}

    function wait(ms){ return new Promise(function(res){ setTimeout(res, ms); }); }
    function attach(code, attempt){
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(function(r){
          if (r && r.ok) return true;
          throw new Error('status ' + (r && r.status));
        })
        .catch(function(){
          if (attempt < 2) return wait(2000).then(function(){ return attach(code, attempt + 1); });
          return false;
        });
    }

    var chain = wait(500).then(function(){ return true; });
    codes.forEach(function(code){
      chain = chain.then(function(okSoFar){
        return attach(code, 1).then(function(ok){ return okSoFar && ok; });
      });
    });
    chain.then(function(allOk){
      if (allOk) { try { sessionStorage.setItem(KEY, 'ok'); } catch (e) {} }
    });
  })();

  document.querySelectorAll('.tlp a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id=a.getAttribute('href').slice(1); var t=document.getElementById(id);
      if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });
})();
